if($('.type-category').length){
   
    $('#content-wrapper').append($('footer#footer .supportUs'));
}

function category(){
    if($('.category-perex p').last().find('img').length){
        $('.category-top').addClass('haveImage').wrapInner('<div class="left"></div>');
        $('.category-top').append($('.category-perex p').last());
    }
    $('.category-header .dropdown-menu li').each(function(){
        $(this).html(function(){
            return $(this).html().replace("Nejlevnější", "Malá pomoc");
        })
        $(this).html(function(){
            return $(this).html().replace("Nejdražší", "Velká pomoc");
        })
        $(this).html(function(){
            return $(this).html().replace("Nejprodávanější", "Nejoblíbenější");
        })
    })

}
    

$(document).ready(function(){
    category();
});
    
document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    category();
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    category();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    category();
});